import React from 'react';
import PropTypes from 'prop-types';
import '../styles/SearchResults.css';
import { IMAGE_URL } from '../api/api';

const SearchResults = ({ items, onSelect, placeholder }) => {
  if (!items.length) {
    return (
      <div className="search-no-results">
        No {placeholder || 'items'} found.
      </div>
    );
  }

  return (
    <ul className="search-results">
      {items.map(item => {
        const key = item.id || item.food_id;
        // subtitle: use item.description or default to "Dish"
        const subtitle = item.subtitle || 'Dish';
        return (
          <li
            key={key}
            className="search-item"
            onClick={() => onSelect(item)}
          >
            <img
              className="search-item-image"
              src={`${IMAGE_URL}${item.image}`}
              alt={item.name}
            />
            <div className="search-item-content">
              <strong className="search-item-title">{item.name}</strong>
              <span className="search-item-subtitle">{subtitle}</span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

SearchResults.propTypes = {
  items: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default SearchResults;
